
export default class EntityHeader {
  constructor() {
    this.editHeaderTitleBtn = document.querySelector('.js-update-entity-header-title-btn');
    this.headerTitleElement = this.editHeaderTitleBtn?.previousElementSibling
    this.headerTitleEditContainer = document.querySelector('.js-update-entity-header-title-edit-container');

    if (this.editHeaderTitleBtn && this.headerTitleElement) {
      this.editHeaderTitleBtn.addEventListener('click', this.onEditTitleButtonClick.bind(this));

      const onCancelButton = document.querySelector('.js-update-entity-header-title-cancel-btn');
      onCancelButton.addEventListener('click', this.onResetHeader.bind(this))

      const onSaveButton = document.querySelector('.js-update-entity-header-title-save-btn');
      onSaveButton.addEventListener('click', this.onSaveEdit.bind(this, onSaveButton))
    }
  }

  onEditTitleButtonClick() {
    this.headerTitleEditContainer.classList.remove('d-none');

    const input = this.headerTitleEditContainer.querySelector('.js-update-entity-header-title-input');
    input.value = this.headerTitleElement.innerText;

    this.headerTitleElement.classList.add('d-none');
    this.editHeaderTitleBtn.classList.add('d-none');
  }

  onResetHeader() {
    this.headerTitleElement.classList.remove('d-none');
    this.editHeaderTitleBtn.classList.remove('d-none');
    this.headerTitleEditContainer.classList.add('d-none');
  }

  onSaveEdit(onSaveButton) {
    const self = this;
    onSaveButton.disabled = true
    const iconElem = onSaveButton.querySelector('span')
    iconElem.classList.replace('fa-check', 'fa-spinner-third')
    iconElem.classList.add('fa-spin')

    const input = self.headerTitleEditContainer.querySelector('.js-update-entity-header-title-input');

    $.ajax({
      type: 'POST',
      url: onSaveButton.dataset.updateUrl,
      data: {
        title: input.value,
      },
      success: function(data) {
        onSaveButton.disabled = false;
        iconElem.classList.replace('fa-spinner-third', 'fa-check')
        iconElem.classList.remove('fa-spin')

        self.headerTitleElement.innerText = input.value

        self.onResetHeader()

        onSaveButton.setAttribute('data-update-url', data.new_update_url)
        history.pushState({}, null, data.success_url);

        $.toast({
          heading: 'Save Success',
          text: 'Your page title has been updated successfully',
          showHideTransition: 'slide',
          icon: 'success',
          hideAfter: 10000,
        });
      },
      error: function() {
        onSaveButton.disabled = false;
        iconElem.classList.replace('fa-spinner-third', 'fa-check')
        iconElem.classList.remove('fa-spin')

        $.toast({
          heading: 'Error',
          text: 'Unable to update your page title, please try again later',
          icon: 'error',
          hideAfter: 10000
        });
      }
    });
  }
}
